import { useEffect, useState } from 'react';
import axios from 'axios';
import { Reply, Loader2, Paperclip } from 'lucide-react';
import { Button } from '../ui/button';

const API = process.env.REACT_APP_BACKEND_URL;
const decodeEntities = (s) => { const t = document.createElement('textarea'); t.innerHTML = s; return t.value; };

const Body = ({ m }) => {
  if (m.html) {
    return <iframe title={m.id} sandbox="allow-popups allow-popups-to-escape-sandbox" srcDoc={`<base target="_blank">${m.html}`}
      className="w-full min-h-[320px] border-0 bg-white" data-testid={`gmail-body-${m.id}`}
      onLoad={(e) => { const d = e.target.contentDocument; if (d) e.target.style.height = `${d.body.scrollHeight + 24}px`; }} />;
  }
  return <pre className="whitespace-pre-wrap font-sans text-sm text-slate-700" data-testid={`gmail-body-${m.id}`}>{m.text}</pre>;
};

const download = async (m, a) => {
  const res = await axios.get(`${API}/api/gmail/messages/${m.id}/attachments/${a.attachment_id}`, { params: { filename: a.filename }, responseType: 'blob' });
  const url = URL.createObjectURL(res.data);
  const link = Object.assign(document.createElement('a'), { href: url, download: a.filename });
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
};

export const ThreadView = ({ threadId, onReply }) => {
  const [thread, setThread] = useState(null);
  useEffect(() => {
    setThread(null);
    axios.get(`${API}/api/gmail/threads/${threadId}`).then((r) => setThread(r.data)).catch(() => setThread({ messages: [] }));
  }, [threadId]);

  if (!thread) return <div className="flex justify-center p-10"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  const last = thread.messages[thread.messages.length - 1];
  return (
    <div className="p-6 space-y-5" data-testid="gmail-thread-view">
      <div className="flex items-start justify-between gap-3">
        <h2 className="text-lg font-bold text-slate-900" data-testid="gmail-thread-subject">{decodeEntities(last?.subject || '(sans objet)')}</h2>
        {last && <Button size="sm" variant="outline" className="gap-2" onClick={() => onReply(thread, last)} data-testid="gmail-reply-btn"><Reply className="h-4 w-4" />Répondre</Button>}
      </div>
      {thread.messages.map((m) => (
        <article key={m.id} className="rounded-xl border border-slate-200 bg-white p-4">
          <header className="mb-3 flex flex-wrap items-baseline justify-between gap-2 text-sm">
            <div><span className="font-semibold text-slate-900">{m.from_name}</span> <span className="text-slate-500">&lt;{m.from_email}&gt;</span>
              <p className="text-xs text-slate-500">À : {m.to}{m.cc ? ` · Cc : ${m.cc}` : ''}</p></div>
            <span className="text-xs text-slate-500">{new Date(m.date).toLocaleString('fr-FR')}</span>
          </header>
          <Body m={m} />
          {m.attachments.length > 0 && (
            <div className="mt-3 flex flex-wrap gap-2">
              {m.attachments.map((a) => (
                <button key={a.attachment_id} onClick={() => download(m, a)} data-testid="gmail-attachment"
                  className="flex items-center gap-1 rounded-full border border-slate-200 px-3 py-1 text-xs text-slate-700 hover:bg-slate-50">
                  <Paperclip className="h-3 w-3" />{a.filename}
                </button>
              ))}
            </div>
          )}
        </article>
      ))}
    </div>
  );
};
